import axios from "axios";
import { usePatientStore } from "@/store/health/blood";
const { VUE_APP_PREPR_API } = process.env;

const ax = axios.create();

const queryString = `
  _id
  product_name
  product_type
  subscription_options {
    body
  }
  _slug
  header_image {
    _id
    url
  }
  product_icon {
    _id
    url
  }
  product_photo {
    _id
    url
  }
  product_header
  product_introduction
  product_detail_header
  product_details
  product_page_tabs {
    name
    body
    icon {
      url
    }
    image {
      url
    }
  }
  how_it_works_header
  how_it_works_widget {
    number
    icon {
      url
    }
    title
    body
  }
  faq_header
  faqs {
    question
    answer
  }
  testimonials_header
  testimonials {
    author
    body
    rating
  }
  price_string
  price
  usa_price
  eur_price
  aus_price
  can_price
  sku
  usa_sku
  eur_sku
  aus_sku
  can_sku
  currency
  subscription_price_string
  subscription_price
  product_descriptor_list
  doctor_profile_image {
    _id
    url
  }
  doctor_name_and_role
  whats_included {
    panel
    markers
  }
  age_tags {
    body
  }
  gender_tags {
    body
  }
  wellbeing_goal_tags {
    body
  }
  collection_methods {
    _id
    _slug
    name
    description
    price_string
    price
    post_order_text
    icon {
      url
    }
  }
  thumbnail_image {
    url
  }
  testimonials {
    author
    body
    rating
    background {
      url
    }
  }
  product_type
  doctor_text
  aus_price_string
  can_price_string
  eur_price_string
  aus_subscription_price_string
  can_subscription_price_string
  usa_subscription_price_string
  eur_subscription_price_string
`;

export async function getProductData(productId) {
  const res = await ax({
    url: VUE_APP_PREPR_API,
    method: "post",
    data: {
      query: `
        query ProductPage($productPageId: String) {
          ProductPage(id: $productPageId) {
            ${queryString}
          }
        }
      `,
      variables: {
        productPageId: productId,
      },
    },
  });
  return res.data.data.ProductPage;
}

export function getHeaderText() {
  return ax({
    url: VUE_APP_PREPR_API,
    method: "post",
    data: {
      query: `
        {
          HeaderText (slug: "your-health") {
            _id
            title
            body
            author {
              __typename
              name
              biography
              photos {
                url
              }
              signature {
                url
              }
            }
          }
        }
      `,
    },
  });
}

export function getDoctorDetails(doctorName) {
  return ax({
    url: VUE_APP_PREPR_API,
    method: "post",
    data: {
      query: `
        {
          Authors(where: { retool_name: "${doctorName}" }) {
            items {
              _id
              name
              biography
              photos {
                _id
                url
              }
              signature {
                _id
                url
              }
              retool_name
            }
          }
        }
      `,
    },
  });
}

export function getStoreCategories() {
  return ax({
    url: VUE_APP_PREPR_API,
    method: "post",
    data: {
      query: `
      {
        StoreCategories {
          items {
            _id
            name
            cover_image {
              _id
              url
            }
            icon {
              _id
              url
            }
            sample_name
            sample_icon {
              _id
              url
            }
            description
            minimum_price_string
            aus_minimum_price_string
            can_minimum_price_string
            usa_minimum_price_string
            eur_minimum_price_string
            product_photo {
              _id
              url
            }
            products {
              __typename
            }
          }
        }
      }
      `,
    },
  });
}

export function getPrice(product) {
  const patientStore = usePatientStore();
  const region = patientStore.patient.region;
  if (region === "GBR") {
    return product.price_string;
  }
  if (region === "AUS") {
    return product.aus_price_string;
  }

  if (region === "CAN") {
    return product.can_price_string;
  }

  if (region === "USA") {
    return product.usa_price_string;
  }

  if (region === "EUR") {
    return product.eur_price_string;
  }
  if (region === "INT") {
    return product.usa_price_string;
  }
}

export function getSubscriptionPrice(product) {
  const patientStore = usePatientStore();
  const region = patientStore.patient.region;
  if (region === "GBR") {
    return product.subscription_price_string;
  }
  if (region === "AUS") {
    return product.aus_subscription_price_string;
  }

  if (region === "CAN") {
    return product.can_subscription_price_string;
  }

  if (region === "USA") {
    return product.usa_subscription_price_string;
  }

  if (region === "EUR") {
    return product.eur_subscription_price_string;
  }

  if (region === "INT") {
    return product.subscription_price_string;
  }
}

export function getMinimumPrice(product) {
  const patientStore = usePatientStore();
  const region = patientStore.patient.region;
  if (region === "GBR") {
    return product.minimum_price_string;
  }
  if (region === "AUS") {
    return product.aus_minimum_price_string;
  }

  if (region === "CAN") {
    return product.can_minimum_price_string;
  }

  if (region === "USA") {
    return product.usa_minimum_price_string;
  }

  if (region === "EUR") {
    return product.eur_minimum_price_string;
  }
}

export function getCurrency() {
  const patientStore = usePatientStore();
  const region = patientStore.patient.region;
  if (region === "GBR") {
    return "gbp";
  }
  if (region === "AUS") {
    return "aus";
  }

  if (region === "CAN") {
    return "can";
  }

  if (region === "USA") {
    return "usa";
  }

  if (region === "EUR") {
    return "eur";
  }
}
